import type { LinkResolverFunction } from '@prismicio/client';

export const linkResolver: LinkResolverFunction = (doc) => {
  console.log(JSON.stringify(doc, null, 2));
  switch (doc.type) {
    case 'home':
      return `/`;
    case 'blog':
      return `/blog/${doc.uid}`;
    case 'Dico chapter details':
      return `/dico/${doc.uid}`;
    case 'entrepreneur homepage':
      return `/${doc.uid}`;
    case 'guide':
      return `/guide/${doc.uid}`;
    case 'pricing-details':
      return `/${doc.uid}`;
    case 'service':
      return `/service/${doc.uid}`;
    case 'toolbox':
      return `/tool-box/${doc.uid}`;
    default:
      return `/${doc.type}`;
  }
};
